import { useState } from "react";

import { useTranslations } from "next-intl";
import Image from "next/image";

import { ButtonComponent, ModalComponent, OtpInput } from "@/components";
import { FormatTime, IMAGES, WEB_COLORS } from "@/lib/constants";
import { QueryBuilder } from "@mui/icons-material";
import { Button, Grid, Stack, Tooltip, Typography } from "@mui/material";

const OtpModal = ({
  showOtpModal,
  setShowOtpModal,
  timeLeft,
  ckycData,
  handleCkycValidate,
  error,
  handleResend,
  onSkip,
  isCloseButtonRequired = true,
  loading,
}) => {
  const [chooseToSkip, setChooseToSkip] = useState(false);
  const t = useTranslations("IdentityDetails");
  const [otp, setOtp] = useState({ value: "", completed: false });
  const handleOnOtpSubmit = () => {
    otp.completed && handleCkycValidate(otp.value);
  }; 


  return (
    <ModalComponent
      closeButtonRequired={isCloseButtonRequired}
      open={showOtpModal}
      handleModal={setShowOtpModal}
      maxWidth="md"
    >
      {!chooseToSkip ? (
        <Stack spacing={2} mx={2}>
          <Typography
            fontWeight={700}
            fontSize={{ xs: 24, md: 32 }}
            align="center"
          >
            CKYC verification
          </Typography>
          <Typography
            align="center"
            fontSize={16}
            color={WEB_COLORS.fadeColor2}
          >
            {(() => {
              // Remove any duplicate 'OTP has been sent' and replace only the mobile part
              const msg = ckycData?.message || "";
              const match = msg.match(
                /(OTP has been sent to the registered mobile number)\s*(X+\d{4})/
              );
              if (match) {
                return "OTP has been sent to the registered mobile number";
              }
              // fallback: remove extra 'OTP has been sent' if present
              return msg.replace(
                /OTP has been sentOTP has been sent/,
                "OTP has been sent"
              );
            })()}
          </Typography>
          {ckycData?.message?.match(/X+\d{4}/) && (
            <Typography
              align="center"
              fontSize={16}
              fontWeight={500}
              color={WEB_COLORS.primary}
            >
              {ckycData?.message.match(/X+\d{4}/)[0]}
            </Typography>
          )}
          <OtpInput
            length={6}
            disableAutoSubmit={true}
            handleOtpOnChange={(data) => setOtp(data)}
            isLoading={loading}
          />
          {error?.data?.message && (
            <Typography
              variant="caption"
              sx={{ color: "#d32f2f" }}
              align="center"
            >
              {error?.data?.message}
            </Typography>
          )}
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <Typography
              variant="span"
              fontSize={{ xs: 14, sm: 16 }}
              color={WEB_COLORS.textFadeColor}
            >
              {timeLeft !== 0 ? t("resendotpin") : t("didntgetotp")}
            </Typography>
            {timeLeft !== 0 ? (
              <>
                <QueryBuilder
                  fontSize="14"
                  sx={{ color: WEB_COLORS.fadeColor2 }}
                />
                <Typography
                  align="center"
                  minWidth={40}
                  maxWidth={40}
                  color={WEB_COLORS.fadeColor2}
                >
                  {FormatTime(timeLeft)}
                </Typography>
              </>
            ) : (
              <Tooltip title="Resend an OTP for the above mobile number">
                <a
                  style={{
                    ml: 1,
                    fontSize: { xs: 14, sm: 16 },
                    cursor: "pointer",
                    color: WEB_COLORS.primary,
                  }}
                  onClick={handleResend}
                >
                  {t("resendotp")}
                </a>
              </Tooltip>
            )}
          </Stack>
          <ButtonComponent disabled={!otp.completed}  type="submit"  onClick={handleOnOtpSubmit}>
            Verify OTP
          </ButtonComponent>
          {timeLeft === 0 && (
            <Stack alignItems={"center"} justifyContent={"center"}>
              <Button
                variant="text"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  setChooseToSkip(true);
                }}
              >
                Skip
              </Button>
            </Stack>
          )}
        </Stack>
      ) : (
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={6}
            display={"flex"}
            bgcolor={WEB_COLORS.pale}
            justifyContent={"center"}
            alignItems={"center"}
            p={2}
            gap={2}
            borderRadius={2}
          >
            <Image src={IMAGES.skipCkyc} alt="Skip CKYC" />
          </Grid>
          <Grid item xs={12} md={6} sx={{ alignSelf: "center" }}>
            <Stack spacing={3}>
              <Typography
                fontWeight={700}
                fontSize={{ xs: 18, sm: 24 }}
                color={WEB_COLORS.primary}
              >
                Are you sure?
              </Typography>
              <Typography color={WEB_COLORS.fadeColor} variant="caption" my={2}>
                If skipped, Aadhaar-based KYC will be required at a later stage.
              </Typography>
              <ButtonComponent type="submit" onClick={onSkip}>
                Proceed Anyway
              </ButtonComponent>
              <ButtonComponent
                type="reset"
                variant="outlined"
                onClick={() => setChooseToSkip(false)}
              >
                Go Back
              </ButtonComponent>
            </Stack>
          </Grid>
        </Grid>
      )}
    </ModalComponent>
  );
};

export default OtpModal;
